import React from "react";
import {
    Pagination
  } from "react-bootstrap";

class PaginationComponent extends React.Component {
    render() {

        const {
            pages,
            current_page,
            start_page,
            end_page
        } = this.props;
        
        let paginationItems = [];
        for (let i = start_page; i <= end_page; i++) {
            paginationItems.push(i === current_page ? 
                <Pagination.Item key={i} onClick={() => this.props.goToPage(i)} active>
                    <a href="foo">
                        {i + 1}
                    </a>
                </Pagination.Item> :
                <Pagination.Item key={i} onClick={() => this.props.goToPage(i)}>
                    <a href="foo">
                        {i + 1}
                    </a>
                </Pagination.Item>);
        }

        return (
            <Pagination bsClass="pagination" className="justify-content-center">
                {current_page === 0 ?
                    <Pagination.First disabled>
                        <a href="foo" onClick={() => this.props.goToPage(0)}>
                            First
                        </a>
                    </Pagination.First> : 
                    <Pagination.First>
                        <a href="foo" onClick={() => this.props.goToPage(0)}>
                            First
                        </a>
                    </Pagination.First>
                }
                {current_page === 0 ?
                    <Pagination.Prev disabled>
                        <a href="foo" onClick={() => this.props.goToPage(current_page - 1)}>
                            Previous
                        </a>
                    </Pagination.Prev> : 
                    <Pagination.Prev >
                        <a href="foo" onClick={() => this.props.goToPage(current_page - 1)}>
                            Previous
                        </a>
                    </Pagination.Prev>
                }
                {paginationItems}
                {current_page === pages - 1 ?
                    <Pagination.Next disabled>
                        <a href="foo" onClick={() => this.props.goToPage(current_page + 1)}>
                            Next
                        </a>
                    </Pagination.Next> :
                    <Pagination.Next>
                        <a href="foo" onClick={() => this.props.goToPage(current_page + 1)}>
                            Next
                        </a>
                    </Pagination.Next>
                }
                {current_page === pages - 1 ?
                    <Pagination.Last disabled>
                        <a href="foo" onClick={() => this.props.goToPage(pages - 1)}>
                            Last
                        </a>
                    </Pagination.Last> :
                    <Pagination.Last>
                        <a href="foo" onClick={() => this.props.goToPage(pages - 1)}>
                            Last
                        </a>
                    </Pagination.Last>
                }
            </Pagination>
        )

    }
}


export default PaginationComponent;
